import * as React from 'react';
import { connect } from 'react-redux';
import { Card, ProgressBar } from 'react-bootstrap';
import { CLAIM_HISTORY_V2 } from '../../../routes/routes';
import { getNextQuestion, getPrevQuestion, resetFeedback, submitFanclubFeedback } from '../../../actions/fanclubActions';
import { navigateTo } from '../../../actions/navigationActions';

class ClaimsFeedback extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            feedback_faces: "active",
            isSelected: false,
            feedbackText: "",
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleDone = this.handleDone.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleToggleSmile = this.handleToggleSmile.bind(this);
        this.handleToggleMeh = this.handleToggleMeh.bind(this);
        this.handleToggleAngry = this.handleToggleAngry.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleClick() {
        if (this.state.feedback_faces !== "active") {
            let rating = "1"
            switch (this.state.feedback_faces) {
                case "smile": rating = "3";
                    break;
                case "meh": rating = "2";
                    break;
                default: rating = "1";
                    break;
            }
            await this.props.dispatchSubmitFeedback(this.props.fanclub.currQuestion.questionId, this.state.feedbackText, rating, this.props.profile.selectedPersonalClaim.claimNumber);
            this.setState({ feedbackText: "", feedback_faces: "active" });
        }
        else {
            this.handleSkip();
        }
    }

    async handleSkip() {
        this.props.handleGetNextStep();
    }

    async handleDone() {
        await this.props.redirectTo(CLAIM_HISTORY_V2)
        await this.props.handleResetFeedback();
    }

    async handleToggle() {
        this.setState({ feedback_faces: "active" });
    }

    async handleToggleSmile() {
        this.setState({ feedback_faces: "smile" });
    }

    async handleToggleMeh() {
        this.setState({ feedback_faces: "meh" });
    }

    async handleToggleAngry() {
        this.setState({ feedback_faces: "angry" });
    }

    async handleBack(e: any) {
        this.props.handleGetPrevQuestion()
    }

    render() {
        let now = 0; // Must be a calculation for each page
        if (this.props.fanclub.currQuestionNumber > 0) {
            now = Math.floor(this.props.fanclub.currQuestionNumber / this.props.fanclub.feedbackQuestions[0].length)
        }
        const progressInstance = <ProgressBar id="claimProgressFeedback" now={now} className="d-none d-lg-block d-md-block" />;
        const progressInstanceMobile = <ProgressBar id="claimProgressFeedbackMobile" now={now} className="d-lg-none d-md-none" />;

        return (
            <div className="pt-lg-5 p-lg-0 pt-5">
                <div id="Feedback">
                    <div className="container-fluid nopa container-width">
                        <div className="row noma justify-content-center">
                            <div className="ma-right-60px d-none d-lg-block d-md-block">
                                <button onClick={this.handleBack} className="backButton-width-91px cursor-pointer"><img src="./Images/Claims/back_arrow.svg" alt="back_arrow" title="" className="ma-right-6px" />Back</button>
                            </div>
                            <div className="col-1 col-md-3 nopa d-lg-none d-md-none" id="backButtonMobile">
                                <button onClick={this.handleBack} className="Back cursor-pointer nopa" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="back-btn" title="" /></button>
                            </div>
                            <div className="ma-top-10px">
                                {progressInstance}
                            </div>
                            <div className="col-11 col-md-9 ma-top-10px">
                                {progressInstanceMobile}
                            </div>
                        </div>
                        <div className="row noma justify-content-center ma-top-50px ma-top-40px">
                            <h2 className="give-feedback-header">Give us your<br className="d-none b-lg-block" /> feedback</h2>
                            <Card className="ma-top-40px ma-top-17px text-center">
                                {this.props.fanclub.feedbackCompleted === true &&
                                    <Card.Body id="feedbackThankYou">
                                        <p className="step-title ma-top-30px text-16">Thanks for your <br className="d-none d-lg-block" /> feedback</p>
                                        <div className="ma-top-50px ma-topbottom">
                                            <img src="./Images/Claims/image-royal-life-desktop.svg" alt="" title="" />
                                        </div>
                                    </Card.Body>
                                }
                                {this.props.fanclub.feedbackCompleted === false &&
                                    <Card.Body id="feedbackBody" className={(this.state.feedback_faces === "smile") ? "nopa feedback_smile-active" : (this.state.feedback_faces === "meh") ? "nopa feedback_meh-active" : (this.state.feedback_faces === "angry") ? "nopa feedback_angry-active" : "nopa feedback-inactive"}>
                                        <p className={(this.state.feedback_faces === "angry") ? "step-title ma-top-30px text-16 text-white" : "step-title text-16 ma-top-30px"}>{this.props.fanclub.currQuestion.questionText}</p>
                                        <div className="ma-top-50px">
                                            <img src={(this.state.feedback_faces === "smile") ? "./Images/Claims/FeedbackFaces/Feedback faces_Smile_active.svg" : "./Images/Claims/FeedbackFaces/Feedback faces_Smile.svg"} alt="" title="" className="ma-right-50px cursor-pointer" onClick={this.handleToggleSmile} />
                                            <img src={(this.state.feedback_faces === "meh") ? "./Images/Claims/FeedbackFaces/Feedback faces_Meh_active.svg" : "./Images/Claims/FeedbackFaces/Feedback faces_Meh.svg"} alt="" title="" className="ma-right-50px cursor-pointer" onClick={this.handleToggleMeh} />
                                            <img src={(this.state.feedback_faces === "angry") ? "./Images/Claims/FeedbackFaces/Feedback faces_Angry_active.svg" : "./Images/Claims/FeedbackFaces/Feedback faces_Angry.svg"} alt="" title="" className=" cursor-pointer" onClick={this.handleToggleAngry} />
                                        </div>
                                        <div className="add_comment-margins">
                                            <p className={(this.state.feedback_faces === "angry") ? "text-left ma-bottom-8px text-white" : "text-left ma-bottom-8px"}><b>Add a comment</b></p>
                                            <textarea placeholder="Start typing..." className="textarea-height" value={this.state.feedbackText} name="feedbackText" onChange={this.handleChange} />
                                        </div>
                                    </Card.Body>}
                                <Card.Footer className="ma-top-20px nopa add_comment-margins">
                                    {this.props.fanclub.feedbackCompleted === false &&
                                        <>
                                            <button className="btn btn-outline-red ma-right-16px ma-right-13px" onClick={this.handleClick}>Skip</button>
                                            <button className="btn btn-solid-red" disabled={this.state.feedback_faces === "active"} onClick={this.handleClick}>Next</button>
                                        </>
                                    }
                                    {this.props.fanclub.feedbackCompleted === true && <button className="btn btn-solid-green width-280px" onClick={this.handleDone}>Okay</button>}
                                </Card.Footer>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        fanclub: state.fanclub
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSubmitFeedback: (questionId: string, answerText: string, answerRating: string, reference: string) => dispatch(submitFanclubFeedback(questionId, answerText, answerRating, reference)),
        handleGetNextStep: () => dispatch(getNextQuestion()),
        handleResetFeedback: () => dispatch(resetFeedback()),
        handleGetPrevQuestion: () => dispatch(getPrevQuestion()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsFeedback);
